module.exports = __webpack_public_path__ + "img/13.444f8991.jpg";